import { createFileRoute } from '@tanstack/react-router';

import { revalidateLocationCapabilities, TOOL_GATES, ToolAccessGate } from 'shared/modules/capabilities';
import { LOCATION_DATA_UNAVAILABLE_PAGE } from 'shared/modules/country-support';

import { LocationSummary } from 'features/locations/LocationSummary';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/summary')({
  // The header's Reviews access reads the location capabilities; refreshing them here keeps the rating
  // from rendering empty or from stale access first.
  loader: ({ context: { queryClient }, params: { id } }) =>
    revalidateLocationCapabilities({ queryClient, locationId: id }),
  component: LocationSummaryRoute
});

function LocationSummaryRoute() {
  const { id } = Route.useParams();

  return (
    <ToolAccessGate
      gate={TOOL_GATES.LOCATION_SUMMARY}
      locationId={id}
      page={LOCATION_DATA_UNAVAILABLE_PAGE.LOCATION_SUMMARY}
    >
      <LocationSummary locationId={id} />
    </ToolAccessGate>
  );
}
